export default __webpack_public_path__ + "static/media/association-icon.1f178410.svg";